export function clamp(value, min = 0, max = 1) {
  return Math.min(max, Math.max(min, value));
}

export function lerp(from, to, amount) {
  return from + (to - from) * amount;
}

export function invLerp(from, to, value) {
  if (from === to) return 0;
  return clamp((value - from) / (to - from));
}

export function smoothstep(edge0, edge1, value) {
  const x = invLerp(edge0, edge1, value);
  return x * x * (3 - 2 * x);
}

export function easeOutCubic(value) {
  return 1 - Math.pow(1 - clamp(value), 3);
}

export function easeInOutSine(value) {
  return -(Math.cos(Math.PI * clamp(value)) - 1) / 2;
}

export function damp(current, target, lambda, deltaSeconds) {
  return lerp(current, target, 1 - Math.exp(-lambda * deltaSeconds));
}

export function hashString(input) {
  let hash = 2166136261;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

export function seededUnit(seed, offset = 0) {
  const x = Math.sin(seed * 12.9898 + offset * 78.233) * 43758.5453;
  return x - Math.floor(x);
}
